import React from 'react';
import Filters from 'src/components/CollegeSearch/Filters';
import Modal from 'shared/components/modal';
import {CollegeSearch} from 'src/types/store';

interface Props {
  show: boolean;
  clearFilters: () => void;
  closeModal: (modalName: string) => void;
  collegeSearch: CollegeSearch;
}

const FiltersMobile = ({show, clearFilters, closeModal, collegeSearch: {totalColleges}}: Props) => {
  const handleExit = () => {
    closeModal('college-search-filters');
  };

  return (
    <Modal show={show} onClose={handleExit} className="college-search-mobile-filters">
      <Modal.TextHeader onClose={handleExit}>Filter</Modal.TextHeader>
      <Modal.Body className="college-search-mobile-filters-body">
        <Filters />
      </Modal.Body>
      <Modal.Footer
        primaryButton={{
          onClick: handleExit,
          text: `View ${totalColleges} Results`,
        }}
        tertiaryButton={{
          onClick: clearFilters,
          text: 'Clear All',
          color: 'red',
        }}
      />
    </Modal>
  );
};

export default FiltersMobile;
